import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins, faXmark, faPlus, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import StakeCard from "../components/StakeCard";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';
import Select from "react-select";

function Stake() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [minimum_amt, setMinimum_amt] = useState();
  const [cycle, setCycle] = useState("Daily");
  const [roi, setRoi] = useState();
  const [maximum_amt, setMaximum_amt] = useState();
  const [crypto, setCrypto] = useState([]);
  const [coin_id, setCoin_id] = useState();
  useEffect(() => {
    if(coin_id && minimum_amt && cycle && roi && maximum_amt){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [coin_id, minimum_amt, cycle, roi, maximum_amt]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [see, setSee] = useState(true);
  const [totalStake, setTotalStake] = useState(0);
  const [closeStake, setCloseStake] = useState(0);
  const [activeStake, setActiveStake] = useState(0);
  const [activestaking, setActivestaking] = useState([]);
  const [closedstaking, setClosedstaking] = useState([]);
  const [allstaking, setAllstaking] = useState([]);
  const [activeTab, setActiveTab] = useState("pools")
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [stakes, setStakes] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchStakes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStakes(data.stakes);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        symbol: coin.symbol,
        value: coin.id,
        label: (
          <>
            <img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" style={{ marginRight: 5 }} />
            {coin.symbol}
          </>
        ),
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStakes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const activeStakes = data.mystakes.filter(stake => stake.status === 1);
        const closedStakes = data.mystakes.filter(stake => stake.status === 0);
        const totalAmount = data.mystakes.reduce((sum, stake) => sum + parseFloat(stake.amount * stake.price), 0);
        const closeAmount = closedStakes.reduce((sum, stake) => sum + parseFloat(stake.amount * stake.price), 0);
        const activeAmount = activeStakes.reduce((sum, stake) => sum + parseFloat(stake.amount * stake.price), 0);
        setAllstaking(data.mystakes);
        setActivestaking(activeStakes);
        setClosedstaking(closedStakes);

        setTotalStake(totalAmount);
        setCloseStake(closeAmount);
        setActiveStake(activeAmount);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);
  const AddStake = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/stake.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addstake: true, coin_id : coin_id, minimum_amt : minimum_amt, cycle : cycle, roi : roi, maximum_amt : maximum_amt})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "stake";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Stake" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Stake" icon={<FontAwesomeIcon icon={faCoins} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="mycard mt-2">
                  <h2 className="fs-4 fw-bold mb-0">{(see === true)?getCurrencySymbol(user?.currency)+formatCurrency(totalStake * rate):'******'}</h2>
                  <p className="text-white fw-semibold mb-0">Total stakings <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} style={{fontSize: '13px', cursor: 'pointer'}} onClick={() => {
                  setSee(see === true ? false : true);
                  }}/></p>
                  <p className="text-secondary fw-semibold mb-0">{allstaking.length} Stakings</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="mycard mt-2">
                  <h2 className="fs-4 fw-bold mb-0">{(see === true)?getCurrencySymbol(user?.currency)+formatCurrency(activeStake * rate):'******'}</h2>
                  <p className="text-white fw-semibold mb-0">Active stakings</p>
                  <p className="text-secondary fw-semibold mb-0">{activestaking.length} Stakings</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="mycard mt-2">
                  <h2 className="fs-4 fw-bold mb-0">{(see === true)?getCurrencySymbol(user?.currency)+formatCurrency(closeStake * rate):'******'}</h2>
                  <p className="text-white fw-semibold mb-0">Closed stakings</p>
                  <p className="text-secondary fw-semibold mb-0">{closedstaking.length} Stakings</p>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-cemter overflow-x-auto mx-2 my-4" style={{cursor:'pointer'}}>
                  <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "pools" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "pools" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("pools");}}>Pools</h6>
                  <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "history" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "history" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("history");}}>Your history</h6>
                </div>
                {activeTab === "pools" && (
                <>
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0 fw-bold text-white ms-2">Pools</h5>
                    {user?.user_type === "adminface" && (
                      <div className="myBtn d-inline-block bg-prime px-3" style={{fontSize: '14px'}} onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} /> Add Pool</div>
                    )}
                  </div>
                  <div className="row">
                    {stakes.map((stake) => (
                      <div className="col-lg-3 col-md-6 col-12 g-4">
                        <StakeCard key={stake.id} coin_id={stake.coin_id} stake_id={stake.stake_id} image={<img src={stake.logo} alt={stake.name} style={{width:'40px'}} />} name={stake.name} symbol={stake.symbol} min={stake.minimum_amt} max={stake.maximum_amt} cycle={stake.cycle} roi={stake.roi}/>
                      </div>
                    ))}
                  </div>
                </>
                )}
                {activeTab === "history" && (
                  <div className="table-responsive scrollDown" style={{maxHeight: '60vh'}}>
                    <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                        <thead>
                          <tr className="fs-7">
                            <th>Ref</th>
                            <th>Amount</th>
                            <th>Duration</th>
                            <th className="text-nowrap">Total (USD)</th>
                            <th>ROI</th>
                            <th className="text-nowrap">Stake Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody style={{fontSize: '14px'}}>
                        {allstaking.length > 0 ? (
                          allstaking.map((staking, key) => (
                                <tr key={key}>
                                  <td>{staking.stake_id}</td>
                                  <td>{formatCurrency(staking.amount)}</td>
                                  <td>{staking.duration} {staking.duration == 1?'Day':'Days'}</td>
                                  <td className="fw-semibold">{formatCurrency(staking.roi_usd)}</td>
                                  <td className="text-nowrap fw-semibold text-success">{staking.roi} {staking.symbol}</td>
                                  <td className="text-nowrap">{staking.date}</td>
                                  <td className="py-3"><span className={`${staking.status == 1?'status-success':'status-danger'}`}>{staking.status == 1?'Open':'Closed'}</span></td>
                                </tr> 
                            ))
                        ) : (
                            <tr>
                                <td className="py-5 text-center" colSpan={7}>You have not staked any asset yet.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
        >
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
            Add staking pool</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Assets:</label>
          <Select 
              options={crypto} 
              value={crypto.find((opt) => opt.value === coin_id)}
              onChange={(selected) => {
                  setCoin_id(selected.value); 
              }}
              isSearchable
              styles={darkThemeStyles}
              className="w-full"
          />
          <div className="row">
            <div className="col-6">
              <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Minimum:</label>
              <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                  <input 
                    type="number"
                    placeholder="1000"
                    className="inputNone"
                    value={minimum_amt}
                    onChange={(e) => setMinimum_amt(e.target.value)}
                  />
                  <div
                    className="fw-bold text-white d-flex align-items-center"
                    style={{
                      backgroundColor: 'rgb(30, 33, 36)',
                      borderRadius: '4px',
                      padding: '6px',
                      fontSize: '14px',
                      cursor: 'pointer' 
                    }}
                  >
                  {(() => {
                      const selectedCoin = crypto.find(opt => opt.value === coin_id);
                      return selectedCoin && (
                        <>
                          <img src={selectedCoin.logo} alt={selectedCoin.symbol} width="20" style={{ marginRight: 5 }} />
                          {selectedCoin.symbol}
                        </>
                      );
                    })()}
                  </div>
              </div>
            </div>
            <div className="col-6">
              <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Maximum:</label>
              <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                  <input 
                    type="number"
                    placeholder="1000"
                    className="inputNone"
                    value={maximum_amt}
                    onChange={(e) => setMaximum_amt(e.target.value)}
                  />
                  <div
                    className="fw-bold text-white d-flex align-items-center"
                    style={{
                      backgroundColor: 'rgb(30, 33, 36)',
                      borderRadius: '4px',
                      padding: '6px',
                      fontSize: '14px',
                      cursor: 'pointer' 
                    }}
                  >
                  {(() => {
                      const selectedCoin = crypto.find(opt => opt.value === coin_id);
                      return selectedCoin && (
                        <>
                          <img src={selectedCoin.logo} alt={selectedCoin.symbol} width="20" style={{ marginRight: 5 }} />
                          {selectedCoin.symbol}
                        </>
                      );
                    })()}
                  </div>
              </div>
            </div>
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Cycle:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="Daily"
                className="inputNone"
                value={cycle}
                onChange={(e) => setCycle(e.target.value)}
              />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>ROI:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="2"
                className="inputNone"
                value={roi}
                onChange={(e) => setRoi(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                %
              </div>
          </div>
          <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddStake : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
        </Modal>
      </div>
    </div>
  )
}

export default Stake